import { render, staticRenderFns } from "./Angebote.vue?vue&type=template&id=206fce2c&"
import script from "./Angebote.vue?vue&type=script&lang=js&"
export * from "./Angebote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports